import { Container } from '@plone/components';
import React from 'react';
import cx from 'clsx';

export type SectionColor = 'brand' | 'subtle' | 'none';
export type SectionWidth = 'layout' | 'default' | 'narrow' | 'full';

/**
 * Faixa de cor full-bleed com conteúdo contido num Container.
 * Cores por token SEMÂNTICO (brand = teal institucional, subtle = cinza
 * de apoio) — ver docs/specs/blocks/section.md §4.1. Tokens de cor e
 * espaçamento em _variables.scss (grupo "Section").
 */
type SectionProps<T extends React.ElementType> = {
  /** Primary content. */
  children: React.ReactNode;
  /** An element type to render as (string or function). */
  as?: T;
  /** Additional CSS classes. */
  className?: string;
  /** Container width */
  width?: SectionWidth;
  color?: SectionColor;
} & React.ComponentPropsWithoutRef<React.ElementType extends T ? 'div' : T>;

export const Section = <T extends React.ElementType = 'div'>(
  props: SectionProps<T>,
) => {
  const {
    as: Component = 'div',
    children,
    className,
    width,
    color = 'none',
    ...rest
  } = props;
  const classes = cx(
    'odc-section',
    {
      [`odc-section--${color}`]: color !== 'none',
    },
    className,
  );

  return (
    <Component {...rest} className={classes}>
      <Container width={width}>{children}</Container>
    </Component>
  );
};
